import { Eye } from 'lucide-react';

import { Callout } from '@/_shared/components/ui/callout';

interface ReadOnlyChatNoticeProps {
  /** Display name of the chat's owner, or null when they have none (dev persona, nameless account). */
  ownerName: string | null;
}

/**
 * Stands in for the composer when you're viewing a chat someone else owns.
 *
 * Only the owner can write to a chat, so there is no control to disable here — the composer is
 * absent, and this explains why rather than leaving an unexplained gap.
 */
export function ReadOnlyChatNotice({ ownerName }: ReadOnlyChatNoticeProps): React.ReactElement {
  return (
    <Callout variant="info" className="items-center">
      <span className="flex items-center gap-2">
        <Eye className="size-4 shrink-0" aria-hidden />
        <span className="min-w-0">
          {ownerName ? `You're viewing ${ownerName}'s chat.` : "You're viewing a shared chat."} Only the chat owner can
          continue the conversation.
        </span>
      </span>
    </Callout>
  );
}
